export const settings = {
  postback: {
    title: 'Настройка',
    url: {
      title: 'Постбэк URL',
      placeholder: 'Укажите URL',
      save: 'Сохранить'
    }
  },

  check: {
    title: 'Проверка номеров',
    verification_type: 'Тип верификации',
    phone: {
      title: 'Номер',
      placeholder: 'Укажите номер',
      button: 'Send'
    },
    code: {
      title: 'SMS-код',
      placeholder: 'Введите код'
    }
  }
};
